export enum ContentType {
  FOTO = 'FOTO',
  PLANIMETRIA = 'PLANIMETRIA',
  VIRTUAL_TOUR = 'VIRTUAL_TOUR',
  PANORAMICA = 'PANORAMICA',
  VIDEO = 'VIDEO',
}
